/**
 * helper function to determine where should successfully order created be routed
 */
export function orderCreatedRoute(orderId: string, isGuest: boolean): string {
  return isGuest ? `/guest-order/${orderId}/success` : `/orders/${orderId}/success`;
}
